import { defineComponent as _defineComponent } from 'vue'
import { mdiClose } from "@mdi/js";
import { computed, ref } from "@nuxtjs/composition-api";

import { useAmplitude } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'LtkAppBadges',
  setup(__props) {

const isOpen = ref(true);
const amplitude = useAmplitude();

const closeIcon = computed(() => mdiClose);

const trackOpenStore = (store: string) => {
  amplitude?.sendDownloadAppEvent("global site banner", store);
};

return { __sfc: true,isOpen, amplitude, closeIcon, trackOpenStore }
}

})